import { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from '@mysimpledb/shared/config/axios';
import '../styles/global.css';
import './ForgotPassword.css';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');
  const [statusType, setStatusType] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const normalizedEmail = String(email || '')
      .trim()
      .toLowerCase();

    if (!normalizedEmail) {
      setStatusType('error');
      setStatus('Please enter your email address.');
      return;
    }

    setSubmitting(true);
    setStatus('');
    setStatusType('');

    try {
      await axios.post('/password/forgot-password', { email: normalizedEmail });

      setStatusType('success');
      setStatus(
        'If an account exists for that email address, we sent password reset instructions.'
      );
    } catch (err) {
      console.error('Forgot password request failed:', err);
      setStatusType('error');
      setStatus(
        err.response?.data?.error ||
          'We could not process the request right now. Please try again.'
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="forgot-page">
      <section
        className="forgot-container"
        aria-labelledby="forgot-password-title"
      >
        <h1 id="forgot-password-title">Forgot your password?</h1>

        <p className="forgot-intro">
          Enter the email address for your account and we’ll send you a secure
          link to choose a new password.
        </p>

        <form onSubmit={handleSubmit} className="forgot-form">
          <label htmlFor="forgot-email">Email address</label>
          <input
            id="forgot-email"
            type="email"
            autoComplete="email"
            inputMode="email"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={submitting}
            required
          />

          <button
            className="standard-button forgot-submit"
            type="submit"
            disabled={submitting}
          >
            {submitting ? 'Sending…' : 'Send Reset Link'}
          </button>
        </form>

        {status ? (
          <div
            className={`forgot-status ${statusType}`}
            role={statusType === 'error' ? 'alert' : 'status'}
          >
            {status}
          </div>
        ) : null}

        <p className="forgot-back">
          <Link to="/login">Back to Sign In</Link>
        </p>
      </section>
    </main>
  );
}

export default ForgotPassword;
